import { USER_OPTIONS } from "../../config/constants.js";

export class UserPublicModel {
  constructor() {

  }

  async getUserInfo(_idcodUser) {
    let user = await app.userPrivateController.auth.getInfoUserFromIdcod(_idcodUser);
    user.occupation = USER_OPTIONS.Cargos.find(i => i.value == user.occupation)?.text || '';
    user.image = APICRUD.Image.GetUrl(user.image);
    if (user.image && user.image.indexOf('/.jpg') > -1) {
      user.image = '/assets/img/user.jpg';
    }
    if (user.image === '') {
      user.image = '/assets/img/user.jpg';
    }
    return user;
  }

  getUserIdcodFromPermalink(_permalink) {
    return APICRUD.Auth.UserFromPermalink(_permalink);
  }

  getItems(_idcodUser) {
    return app.itemsController.model.search('idcodUserCreate', _idcodUser, 'desc');
  }
}
